import { NSARouterMakerResult } from "namirasoft-account-react";
import { MessageLayout } from "../MessageLayout";
import { MessageEntities } from "../MessageEntities";
import { MessageRouterProps } from "../MessageRouterProps";

interface MessageViewPageProps extends NSARouterMakerResult, MessageRouterProps
{ }

function MessageViewPage(props: MessageViewPageProps)
{
	return (
		<MessageLayout {...props}
			action={{
				title: "",
				description: "View the details of a role you’ve defined.",
				menus: {}
			}}
			pages={{
				entity: MessageEntities.message(props, false),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				view: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
					},
					onRowLoaded: (row) =>
					{
						if (!row.seen_at)
							props.servers.message.message.Seen(row.id).catch(() => { });
					}
				}
			}}
		>
			<></>
		</MessageLayout>
	);
}

export default MessageViewPage;